export default "__VITE_ASSET__CwG5497e__"